import classes from './_gridLayout.module.css';

export function A1() {
  return (
    <div className={classes.gridA1}>
      <div className={classes.logo}>&#129302;</div>
    </div>
  );
} 